<template>
  <v-row>
    <v-col xl="6" lg="6" md="8" sm="12">
      <v-card class="m-2">
        <v-card-text>
          <v-row>
            <v-col sm="4" md="2">
              <v-subheader class="c-label">Name</v-subheader>
              <v-subheader class="c-label">Leistungsgruppe</v-subheader>
              <v-subheader class="c-label">Erschwerniszulage</v-subheader>
            </v-col>
            <v-col>
              <v-text-field
                  class="hide-label"
                  v-model="lear.name"
                  :rules="rules.name"
                  counter
                  maxlength="50"
                  hint="Der Name der Leistungsart"
                  label="Name"
                  @input="$emit('change', legr.id)"
              ></v-text-field>
              <v-select
                  class="hide-label"
                  v-model="lear.legr"
                  :items="legrs"
                  label="Leistungsgruppe"
                  hint="Die Leistungsgruppe der Leistungsart"
                  :item-value="'name'"
                  :item-text="'name'"
                  @input="$emit('change', lear.id)"
                  :rules="rules.legr"
              ></v-select>
              <v-select
                  class="hide-label"
                  v-model="lear.lohn_surcharge"
                  :items="ezs"
                  label="Erschwerniszulage"
                  hint="Die Erschwerniszulage der Leistungsart"
                  :item-value="'access'"
                  :item-text="'name'"
                  @input="$emit('change', lear.id)"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "lear_detail",
  props:{
    item: {
      type: Object,
      default: () => {
        return {
          id: '',
          bis_id: '',
          name: '',
          access: '',
          legr: '',
          lohn_surcharge: '',
        }
      }
    },
    lears: {
      type: Array,
      default: () => []
    },
    legrs: {
      type: Array,
      default: () => []
    },
    ezs: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      lear: {
        id: '',
        bis_id: '',
        name: '',
        access: '',
        legr: '',
        lohn_surcharge: '',
      },
      canEdit: false,
      rules: {
        name: [val => (val || '').length > 0 || '*erforderlich'],
        legr: [val => (val || '').length > 0 || '*erforderlich'],
      },
    }
  },
  watch: {
    item: {
      handler: function (newVal) {
        this.lear = {...newVal};
      },
      deep: true
    },
  },
  mounted() {
    this.canEdit = this.$cookies.get("ps_username") === 'admin';
    this.lear = {...this.item};
  },
  methods: {
    isValid() {
      return this.lear.name.trim().length > 0;
    },
    resetEdit() {
      this.lear = {...this.item};
    },
    getData() {
      return this.lear;
    }
  }
}
</script>

<style scoped>
::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.86);
}

::v-deep .hide-label {
  padding-top: 0px !important;
}

::v-deep .hide-label .v-label {
  display: none !important;
}

.c-label {
  margin-bottom: 10px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}
</style>
